module.exports = __webpack_public_path__ + "img/menu-red.60c255e.svg";